export function globalAttributeIdKeyBuilderFromCondition(attributeId) {
	const model = attributeId.SharedConfigurationModelId ? ['shared', attributeId.SharedConfigurationModelId] : ['root'];
	const path = [
		...model,
		...(attributeId.ComponentPath ?? []),
		attributeId.LocalId
	];
	return path.join('::');
}
